export const fixScrollPosition = (
  container: HTMLDivElement,
  header: HTMLDivElement,
  col: number,
  compensation: number
) => {
  const containerWidth = container.offsetWidth;
  const currentScroll = container.scrollLeft;
  const element = header.children[col + 1] as HTMLElement;
  const colPos = {
    left: element.offsetLeft,
    right: element.offsetLeft + element.offsetWidth,
  };
  const overflownRight = colPos.right > containerWidth + currentScroll;
  const overflownLeft = colPos.left < currentScroll;
  if (overflownRight) {
    container.scrollLeft = colPos.right - containerWidth - 24 + compensation;
  }
  if (overflownLeft) {
    container.scrollLeft = col === 0 ? 0 : colPos.left - 24 - compensation;
  }
};



// WEBPACK FOOTER //
// ./src/views/LinkCreateBulk/components/services/fixScrollPosition.ts